export default {
    bindings: {
        content: '<'
    },
    controller: 'checkoutController',
    template: require('../views/checkout.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/components/checkout.component.js